import { Button, Grid, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import KenInputField from '../../../global_components/KenInputField';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenLoader from '../../../Components/KenLoader/index';
import moment from 'moment';
import KenSnackBar from '../../../global_components/KenSnackbar';
import {
  departmentOptions,
  monthOptions,
  // universityOptions,
  yearOptions,
} from './data/data';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import {
  getAcademicFilter,
  postProgramBatchSpecialization,
} from '../../../Utils/apiServices';
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  TextField: {
    width: '100% !important',
    margin: '0 !important',
    height: '1.1876em',
  },
}));
const Program = ({setTabValue}) => {
  const min = 1;
  const max = 17;
  const [value, setValue] = useState('');
  const classes = useStyles();
  const defaultValues = {
    university: '',
    department: '',
    course: '',
    startDate: '',
    endDate: '',
    year: '',
    month: '',
  };

  const [formValues, setFormValues] = useState(defaultValues);
  const [programName, setProgramName] = useState('');
  const [alias, setAlias] = useState('');
  const [term, setTerm] = useState('');
  const [termDuration, setTermDuration] = useState('');
  const [name, setName] = React.useState('');
  const [universityOptions, setUniversityOptions] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [Submit,setSubmit] = React.useState(false);
  const [Error, setError] = React.useState('');
  const [Erroralias, setErroralias] = React.useState('');
  const [inputFields, setInputFields] = useState([]);
  // const [error, setInputFields] = useState([]);
  const [terms, setTerms] = useState('No of terms');
  const idGenerater = () => {
    let id = Math.random().toString(36).substr(2, 9);
    return id;
  };

   //   SnackBar
   const [openSnackbar, setOpenSnackbar] = React.useState(false);
   const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
   const [snackbarMessage, setSnackbarMessage] = React.useState('');

   const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };


  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const handleCancel = () => {
    const resetvalue = {
      ...formValues,
      university: '',
      department: '',
      course: '',
      startDate: '',
      endDate: '',
      year: '',
      month: '',
    };
    setFormValues(resetvalue);
    setProgramName('');
    setAlias('');
    setValue('');
    setTermDuration('');
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  useEffect(() => {
    if (formValues.year && formValues.month) {
      const month = (parseInt(formValues.year * 12) + parseInt(formValues.month)) * 4.34524 ;
      // console.log('formValues.year', Math.round(month));
      var newMonth = Math.round(month);
      setTermDuration(newMonth);
    }
  }, [formValues.month, formValues.year]);
  const handleChangeName = (e) => {
    setName(e.target.name);
  };
  const handleChangeTerm = (e) => {
    setTerm(e.target.name);
  };
  const handleInputsChange = (e) => {
    setProgramName(e.target.value);
    console.log(e.target.value);
    if((/[^0-9]/).test(e.target.value)){
    setError('');
    setSubmit(false);
    }else{
      setError("Please enter valid program name");
      setSubmit(true);
    }
  }
  const handleInputChanges = (e) => {
    setAlias(e.target.value);
    console.log(e.target.value);
    if((/[^0-9]/).test(e.target.value)){
      setErroralias('');
      setSubmit(false);
    }else{
      setErroralias("Please enter valid program alias");
      setSubmit(true);
    }
  }

  console.log(Submit);
  

  const history = useHistory();
  // const handleFilters = () => {};

  React.useEffect(() => {
    setLoading(true);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        Object.entries(res['University Department']).map(([item, keyVal]) => {
          courseOptions.push({ label: item, value: item });
        });
        setUniversityOptions(courseOptions);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const addProgram = () => {
    let payload = {
      Program: {
        academicProgramsName: programName,
        levelOfAcademicProgram: formValues.university,
        academicProgramsAlias: alias,
        duration: {
          year: formValues.year,
          months: formValues.month,
        },
        numberofTerms: value,

        termduration: termDuration,
      },
      Batch: {
        academicProgramsName: '',
        batchName: '',
        startDate: '',
        endDate: '',
        batchStrength: '',
        year: '',
        intake: '',
      },
      Specialization: {
        academicProgramsName: '',
        specializationName: '',
      },
    };
    setLoading(true);
    postProgramBatchSpecialization(payload)
      .then((res) => {
        console.log(res);
        if (res.success) {
          // alert(res.message);
          handleSnackbarOpen('success',`${res.message}`);
          setLoading(false);
          setTimeout(() => {
            // history.push('/app/current-programmes');
            setTabValue(1)
          }, 1000);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  

  return (
    <>
    <KenSnackBar
          message={snackbarMessage}
          severity={snackbarSeverity}
          autoHideDuration={4000}
          open={openSnackbar}
          handleSnackbarClose={handleSnackbarClose}
          position="Bottom-Right"
        />
    <Grid container spacing={2} style={{ maxWidth: 400 }}>
      {loading && <KenLoader />}
      <Grid item xs={12}>
        <KenInputField
          label="Program Name"
          placeholder="Program Name (eg. Master of Business Administration)"
          name="programName"
          // onChange={(e) => setProgramName(e.target.value)}
          onChange={(e) => handleInputsChange(e)}
          value={programName}
          required={true}
          // className={classes.textInputField}
        />
        <p style={{ color: 'red',fontSize:'11px' }}>{Error}</p>
      </Grid>
      <Grid item xs={12}>
        <KenInputField
          label="Program Alias"
          placeholder="Program Alias(eg. MBA)"
          name="programAlias"
          // onChange={(e) => setAlias(e.target.value) }
          onChange={(e) => handleInputChanges(e)}
          value={alias}
          required={true}
          // className={classes.textInputField}
        />
        <p style={{ color: 'red',fontSize:'11px' }}>{Erroralias}</p>
      </Grid>
      <Grid item xs={12}>
        <KenSelectWrap
          name="university"
          label="Level of Academic Program"
          options={universityOptions}
          value={formValues.university}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required={true}
        />
      </Grid>
      {/* <Grid item xs={12}>
        <KenSelectWrap
          name="department"
          label="Department"
          options={departmentOptions}
          value={formValues.department}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required
        />
      </Grid> */}
      <Grid item xs={12}>
        <small>Duration of the program</small>
      </Grid>

      <Grid item xs={6}>
        <KenSelectWrap
          name="year"
          label="Year"
          options={yearOptions}
          value={formValues.year}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required={true}
        />
      </Grid>
      <Grid item xs={6}>
        <KenSelectWrap
          name="month"
          label="Month"
          options={monthOptions}
          value={formValues.month}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required={true}
        />
      </Grid>
      <Grid item xs={12} style={{ marginTop: '10px' }}>
        <KenInputField
          label="Program Duration (in Weeks)"
          required={true}
          placeholder="Program Duration(eg. 0 year and 6 months selected 24 weeks)"
          name="termDuration"
          onChange={(e) => setTermDuration(e.target.value)}
          value={termDuration}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          className={classes.TextField}
          required={true}
          id="outlined-basic"
          label={terms}
          variant="outlined"
          type="number"
          size="small"
          inputProps={{ min, max }}
          value={value}
          onChange={(e) => {
            var value = parseInt(e.target.value, 10);

            // if (value > max) {}
            if (value < min) value = min;

            setValue(value);
          }}
        />
      </Grid>
      {value > max ? (
        <small style={{ marginTop: '10px', color: 'red' }}>
          No of terms should be within 17
        </small>
      ) : (
        ''
      )}

      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '10px',
        }}
      >
        <Button
          variant="outlined"
          // onClick={handleFilters}
          onClick={handleCancel}
          style={{ height: '37px', marginRight: '10px' }}
        >
          Cancel
        </Button>
        {/* <Button variant="contained" color="primary" disabled={Submit?true:false} onClick={addProgram}>
          Submit
        </Button> */}
        <Button variant="contained" color="primary"  onClick={addProgram} disabled={!Submit&&programName&&formValues.university&&alias&&value&& termDuration&&formValues.year&& formValues.month?false:true}>Submit</Button>
      </Grid>
    </Grid>
    </>
  );
};

export default Program;
